import { dropStatusDocumento } from 'utils/drops';

const getRequisiçõesFilterFields = (drops = {}, user) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento,
    multiple: true,
    defaultValue: [],
  },
  { name: 'descricao', label: 'Descrição', defaultValue: '' },
  { name: 'referencia', label: 'Referência', defaultValue: '' },
  {
    name: 'quantidade',
    label: 'Quantidade',
    type: 'currency',
    defaultValue: '',
  },
  {
    name: 'unidade_medida',
    label: 'Unidade de Medida',
    type: 'select',
    options: drops?.UnidadeMedida,
    multiple: true,
    defaultValue: [],
  },
  { name: 'preco', label: 'Preço', type: 'currency', defaultValue: '' },
  {
    name: 'requisitante',
    label: 'Requisitante',
    type: 'select',
    options: drops?.Users,
    multiple: true,
    disabled: user?.permissoes?.block_compras_requisicoes_grid,
    defaultValue: user?.permissoes?.block_compras_requisicoes_grid
      ? [user?.id]
      : [],
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Data de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    defaultValue: '',
    initial: true,
  },
  {
    name: 'filial',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'cegrupo_id',
    label: 'Grupo',
    type: 'select',
    options: drops?.GrupoProduto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'celinha_id',
    label: 'Linha',
    type: 'select',
    options: drops?.LinhaProduto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'cemarca_id',
    label: 'Marca',
    type: 'select',
    options: drops?.Marca,
    multiple: true,
    defaultValue: [],
  },
  { name: 'historico', label: 'Histórico', defaultValue: '' },
  { name: 'especificacao', label: 'Especificação', defaultValue: '' },
];

export default getRequisiçõesFilterFields;
